import Alertphone from './AlertPhone';
import { SIZE } from './constants';

export default Alertphone;
export { SIZE };